import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import * as fromSuccessStoriesState from "./reducer";
import { EffectsModule } from "@ngrx/effects";
import { SuccessStoriesEffects } from "./effects";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromSuccessStoriesState.successStoriesStateFeatureKey,
            fromSuccessStoriesState.successStoriesReducer,
        ),
        EffectsModule.forFeature([SuccessStoriesEffects]),
    ],
})
export class SuccessStoriesModule {}
